export default __webpack_public_path__ + "static/media/minicard8.8cc69631.jpg";